export class ColorAdjustmentUtils {
    // Aclarar color
    static adjustColorLuminosity(color: string, luminosity: number): string {
      // Remover los espacios en blanco de la cadena de color
      const trimmedColor = color.trim();
  
      if (trimmedColor.startsWith('#')) {
        // Convertir el valor hexadecimal a RGB
        const rgbColor = hexToRgb(trimmedColor);
  
        if (rgbColor) {
          // Extraer los valores RGB de la cadena convertida
          const { r, g, b } = rgbColor;
  
          // Calcular el nuevo valor de luminosidad
          const adjustedR = Math.round(r + (luminosity * (255 - r)));
          const adjustedG = Math.round(g + (luminosity * (255 - g)));
          const adjustedB = Math.round(b + (luminosity * (255 - b)));
  
          // Retornar el nuevo color en formato hexadecimal
          return rgbToHex(adjustedR, adjustedG, adjustedB);
        }
      }
  
      // Si el formato del color no es reconocido, retornar el color original sin modificaciones
      return color;
    }

    // Oscurecer color
    static adjustColorDarkness(color: string, darkness: number): string {
      const trimmedColor = color.trim();
  
      if (trimmedColor.startsWith('#')) {
        const rgbColor = hexToRgb(trimmedColor);
  
        if (rgbColor) {
          const { r, g, b } = rgbColor;
  
          const darkenedR = Math.round(r * (1 - darkness));
          const darkenedG = Math.round(g * (1 - darkness));
          const darkenedB = Math.round(b * (1 - darkness));
  
          return rgbToHex(darkenedR, darkenedG, darkenedB);
        }
      }
  
      return color;
    }
  }
  
  // Función para convertir un color hexadecimal a RGB
  function hexToRgb(hex: string): { r: number; g: number; b: number } | null {
    const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    const fullHexRegex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
  
    const result = fullHexRegex.exec(hex) || shorthandRegex.exec(hex);
  
    if (result) {
      const r = parseInt(result[1], 16);
      const g = parseInt(result[2], 16);
      const b = parseInt(result[3], 16);
  
      return { r, g, b };
    }
  
    return null;
  }
  
  // Función para convertir un color RGB a hexadecimal
  function rgbToHex(r: number, g: number, b: number): string {
    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`;
  }
  
  // Función auxiliar para convertir un componente de color a formato hexadecimal
  function componentToHex(c: number): string {
    const hex = c.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
  }
  